import { combineReducers } from '@reduxjs/toolkit'
import { appBarReducer } from 'src/admin/core/stores/appState/reducer'

const rootReducer = combineReducers({
  appState: appBarReducer,
})

export default rootReducer
